import { useMutation } from "@tanstack/react-query";

import { request } from "@/lib/request";
import { Profile } from "@/lib/types";
import { useUser } from "../useUserProvider";

export const useCreateProfileFromTemplate = () => {
  const { accessToken } = useUser();

  return useMutation({
    mutationKey: ["createProfileFromTemplate"],
    meta: {
      analytics: {
        successEvent: "dashboard_template_used",
      },
    },
    mutationFn: async ({
      templateId,
      name,
    }: {
      templateId: string;
      name?: string;
    }): Promise<Profile> => {
      if (!accessToken) {
        throw new Error(
          "You need to be logged in to create dashboards from templates.",
        );
      }

      const res = await request
        .post<{ data: Profile }>(`/templates/${templateId}/profiles`, {
          ...(name?.trim() ? { name: name.trim() } : {}),
        })
        .catch(err => {
          throw new Error(
            err.response?.data.message
              ? err.response?.data.message
              : "Failed to create dashboard from template.",
          );
        });

      return res.data.data;
    },
  });
};
